// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1___b35424269fa01c9b64d","cls2":"Modal-cls2__e9d4e397bf2a0f46a5ae Modal-cls1___b35424269fa01c9b64d"};